import * as React from 'react';

export function UsersIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
			<path d='M16 3.128a4 4 0 0 1 0 7.744' />
			<path d='M22 21v-2a4 4 0 0 0-3-3.87' />
			<circle cx='9' cy='7' r='4' />
		</svg>
	);
}
